/* Public Klaviyo client APIs only. Never put a private API key in this asset. */
(function () {
  'use strict';

  var REVISION = '2026-07-15';
  var REQUEST_TIMEOUT = 15000;

  function createRequest(email, advice) {
    var uniqueId = window.crypto.randomUUID();
    var properties = Object.assign(JSON.parse(JSON.stringify(advice)), {
      schema_version: 1,
      request_id: uniqueId,
      source: 'Keuzehulp',
      requested_at: new Date().toISOString()
    });

    return {
      email: email.trim(),
      uniqueId: uniqueId,
      properties: properties,
      subscriptionAccepted: false,
      accepted: false
    };
  }

  async function post(resource, data, options) {
    var controller = new AbortController();
    var abort = function () { controller.abort(); };
    if (options.signal?.aborted) throw new DOMException('Request cancelled', 'AbortError');
    options.signal?.addEventListener('abort', abort, { once: true });
    var timer = window.setTimeout(abort, REQUEST_TIMEOUT);

    try {
      var response = await (options.fetcher || window.fetch.bind(window))(
        'https://a.klaviyo.com/client/' + resource + '/?company_id=' + encodeURIComponent(options.siteId),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            Accept: 'application/vnd.api+json',
            revision: REVISION
          },
          credentials: 'omit',
          referrerPolicy: 'no-referrer',
          signal: controller.signal,
          body: JSON.stringify({ data: data })
        }
      );
      if (controller.signal.aborted) throw new DOMException('Request cancelled', 'AbortError');
      if (response.status !== 202) throw new Error('Klaviyo request was not accepted');
    } finally {
      window.clearTimeout(timer);
      options.signal?.removeEventListener('abort', abort);
    }
  }

  async function send(request, options) {
    if (!options.siteId || !options.listId) throw new Error('Klaviyo signup is not configured');
    if (options.signal?.aborted) throw new DOMException('Request cancelled', 'AbortError');
    if (request.accepted) return;

    if (!request.subscriptionAccepted) {
      await post('subscriptions', {
        type: 'subscription',
        attributes: {
          custom_source: 'Keuzehulp',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: request.email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: options.listId } } }
      }, options);
      request.subscriptionAccepted = true;
    }

    // Acceptance can precede double opt-in confirmation. The Klaviyo flow owns
    // consent-aware delivery; an accepted event is not proof of email delivery.
    await post('events', {
      type: 'event',
      attributes: {
        unique_id: request.uniqueId,
        time: request.properties.requested_at,
        metric: { data: { type: 'metric', attributes: { name: 'Keuzehulp Advice Requested' } } },
        profile: { data: { type: 'profile', attributes: { email: request.email } } },
        properties: request.properties
      }
    }, options);
    request.accepted = true;
  }

  window.DreaverChoiceWizardEmail = { createRequest: createRequest, send: send };
  document.dispatchEvent(new CustomEvent('choice-wizard:email-ready'));
})();
